
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { PlanReplacementModel } from './Entities.GormCrm.PlanReplacement';
import { ProductPlanModel } from './Entities.GormCrm.ProductPlan';
import { Model, ModelProperty } from 'models/Model';


export class PlanReplacementNewPlanModel extends Model<PlanReplacementNewPlanModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'id', type: 'string', isHidden: true },
		{ name: 'planReplacementId', type: 'string' },
		{ name: 'productPlanId', type: 'string' },
		{ name: 'equalizingAmount', type: 'number' },
		{ name: 'equalizingRemainingValue', type: 'number' },
		{ name: 'equalizingPercentage', type: 'number' },
		{ name: 'planReplacement', type: 'PlanReplacementModel', isHidden: true, isObject: true, new: () => { return new PlanReplacementModel }, properties: () => { return PlanReplacementModel.classProperties } },
		{ name: 'productPlan', type: 'ProductPlanModel', isHidden: true, isObject: true, new: () => { return new ProductPlanModel }, properties: () => { return ProductPlanModel.classProperties } }
	];
	[key: string]: any;
	
	public id?: string;
	public planReplacementId?: string;
	public productPlanId?: string;
	public equalizingAmount: number;
	public equalizingRemainingValue: number;
	public equalizingPercentage: number;
	public planReplacement?: PlanReplacementModel;
	public productPlan?: ProductPlanModel;
    
	constructor(){
		super();
		this.id = undefined;
		this.planReplacementId = undefined;
		this.productPlanId = undefined;
		this.equalizingAmount = 0;
		this.equalizingRemainingValue = 0;
		this.equalizingPercentage = 0;
		this.planReplacement = undefined;
		this.productPlan = undefined;
		
	}
	getProperties(){
		return PlanReplacementNewPlanModel.classProperties;
	}
}

